"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lydia = void 0;
exports.lydia = {
    router: '0xFb26525B14048B7BB1F3794F6129176195Db7766',
};
